// Single source of content for the marketing site. Placeholder text marked
// "to be added" is kept until the clinic supplies the real details.

export const NAV = [
  { id: 'home', label: 'Home' },
  { id: 'about', label: 'About' },
  { id: 'services', label: 'Services' },
  { id: 'why-us', label: 'Why Us' },
  { id: 'branches', label: 'Branches' },
  { id: 'team', label: 'Team' },
  { id: 'contact', label: 'Contact Us', cta: true },
];

export const ABOUT_POINTS = [
  'Personalized care tailored to every patient',
  'Comfortable, welcoming clinic environment',
  'Dedicated doctors and support staff at both branches',
  'Focus on long-term oral health and confident smiles',
];

export const STATS_BAND = [
  { emoji: '🏢', value: '2', label: 'Clinic Branches' },
  { emoji: '👨‍⚕️', value: '2', label: 'Expert Doctors' },
  { emoji: '🤝', value: 'Dedicated', label: 'Support Staff' },
  { emoji: '💙', value: 'Personal', label: 'Dental Care' },
];

export const SERVICES = [
  {
    icon: 'activity',
    bg: '#FFF0F5',
    title: 'General Dentistry',
    text: 'Routine exams, X-rays, fillings, and preventive care to maintain optimal oral health for every member of the family.',
  },
  {
    icon: 'star',
    bg: '#FFF8E7',
    title: 'Teeth Whitening',
    text: 'Professional-grade whitening treatments that safely and effectively brighten your smile, removing stains and discolouration.',
  },
  {
    icon: 'globe',
    bg: '#F0F5FF',
    title: 'Dental Implants',
    text: 'Permanent, natural-looking tooth replacements anchored to the jawbone, restoring your smile and confidence completely.',
  },
  {
    icon: 'shield',
    bg: '#F0FFF4',
    title: 'Orthodontics',
    text: 'Braces and alignment solutions to straighten teeth and correct bite issues for both children and adults.',
  },
  {
    icon: 'users',
    bg: '#FFF9F0',
    title: 'Pediatric Dentistry',
    text: 'Gentle, child-friendly care designed to build healthy dental habits and make every young patient feel at ease.',
  },
  {
    icon: 'alert',
    bg: '#FFF0F0',
    title: 'Emergency Dental',
    text: 'Prompt care for urgent dental concerns — we prioritize your comfort and act swiftly when it matters most.',
  },
];

export const WHY_LIST = [
  'Gentle, stress-free dental experience',
  'Personalized treatment for every patient',
  'Caring, experienced dental team',
  'Family-friendly care for all ages',
  'Two convenient branch locations',
  'Clear, honest communication always',
];

export const WHY_CARDS = [
  { emoji: '🏢', title: '2 Branches', text: 'Two convenient clinic locations to serve you better' },
  { emoji: '👨‍⚕️', title: 'Expert Team', text: 'Qualified, compassionate doctors committed to your care' },
  { emoji: '💝', title: 'Patient First', text: 'Your comfort and satisfaction are always our top priority' },
  { emoji: '🌟', title: 'Family Care', text: 'Comprehensive dental care for patients of every age' },
];

export const TESTIMONIALS = [
  {
    initials: 'RM',
    name: 'Ravi M.',
    role: 'Patient',
    quote:
      'The team at Kanaga Dental made my dental visit completely stress-free. The doctors are gentle and thorough, and the staff are always warm and welcoming. I finally found a clinic I actually look forward to visiting.',
  },
  {
    initials: 'PS',
    name: 'Priya S.',
    role: 'Patient',
    quote:
      'My children used to be nervous about the dentist — not anymore. The pediatric care here is exceptional. The clinic is child-friendly, the staff are incredibly patient, and my kids leave with big smiles every time.',
  },
  {
    initials: 'AK',
    name: 'Anand K.',
    role: 'Patient',
    quote:
      "Professional, clean, and genuinely caring. I've been coming to Kanaga Dental and every visit is consistently excellent. The doctors explain everything clearly and always make you feel in very good hands.",
  },
];

export const FAQS = [
  {
    q: 'How often should I visit the dentist?',
    a: 'We recommend a routine check-up and cleaning every six months for most patients. Regular visits allow us to catch potential issues early and help keep your teeth and gums in excellent condition.',
  },
  {
    q: 'Do you offer dental care for children?',
    a: 'Absolutely. We provide gentle, child-friendly dental services at both our branches. Our team is experienced in making young patients feel comfortable and building positive dental habits from an early age.',
  },
  {
    q: 'What should I do in a dental emergency?',
    a: 'Contact us immediately. We treat dental emergencies as a priority and will do our best to see you as soon as possible. In the meantime, avoid eating or drinking anything very hot or cold near the affected area.',
  },
  {
    q: 'Is teeth whitening safe?',
    a: 'Yes, professional teeth whitening performed under dental supervision is safe and effective. We assess your teeth and gums beforehand to ensure whitening is suitable for you and recommend the right treatment.',
  },
  {
    q: 'How long do dental implants last?',
    a: 'With proper care and regular dental visits, dental implants can last many years — often a lifetime. Good oral hygiene and routine check-ups are key to maintaining the longevity of your implants.',
  },
  {
    q: 'How do I get in touch or arrange a visit?',
    a: "You can reach us through the contact form on this page, by phone, or by email. We'll respond promptly to confirm your details and arrange a convenient time for your visit at either branch.",
  },
];

export const BRANCHES = [
  {
    tag: 'Branch 1',
    name: 'Kanaga Dental Clinic',
    address: 'Address to be added',
    phone: 'Phone to be added',
    hours: 'Working hours to be added',
  },
  {
    tag: 'Branch 2',
    name: 'Kanaga Dental Clinic',
    address: 'Address to be added',
    phone: 'Phone to be added',
    hours: 'Working hours to be added',
  },
];

export const DOCTORS = [
  {
    name: 'Doctor Name 1',
    qual: 'Qualification to be added',
    desc: 'Dedicated to providing gentle, patient-focused dental care with a warm and professional approach at Kanaga Dental Clinic.',
    branch: 'Branch to be confirmed',
  },
  {
    name: 'Doctor Name 2',
    qual: 'Qualification to be added',
    desc: 'Committed to helping patients of all ages achieve excellent oral health through compassionate, personalized treatment plans.',
    branch: 'Branch to be confirmed',
  },
];

export const CONTACT_INFO = [
  { icon: '📍', label: 'Address', value: 'To be added' },
  { icon: '📞', label: 'Phone', value: 'To be added' },
  { icon: '✉️', label: 'Email', value: 'To be added' },
  { icon: '🕐', label: 'Working Hours', value: 'To be added' },
];

export const FOOTER_CONTACT = [
  '📍 Address to be added',
  '📞 Phone to be added',
  '✉️ Email to be added',
  '🕐 Hours to be added',
];
